import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe.components/common/modal/modal.indra.service';
import { FeaturesMap } from '@ibe.models/flight.model.lib';
import { getBrandFeatures } from '@ibe/models/ui';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import * as fromStore from '@ibe/store/index';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';


@Component({
	selector: 'app-add-extra-modal',
	templateUrl: './add-extra-modal.indra.component.html',
	styleUrls: ['./add-extra-modal.component.scss']
})
export class INDRAAddExtraModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {

	flights$: Observable<any> = this.store.pipe(select(fromStore.getSelectedBookedTripFlights));
	title$: Observable<string> = this.store.select(fromStore.getConfirmModalTitle);
	extra_features = [];
	feature;
	isAlive = true;
	flightDetails: any;
	flight: any;

	constructor(
		private store: Store<fromStore.State>,
		protected modalService: ModalService) {
		super(modalService);
		this.TYPE = '';
	}

	ngOnInit() {
		if (this.data && this.data.length) {
			if (this.data[0].feature) {
				this.feature = this.data[0].feature;
			}
			if (this.data[0].flightDetails) {
				this.flightDetails = this.data[0].flightDetails;
			}
		}

		// this.feature =

		this.flights$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(flights => {
				if (flights) {
					this.flight = flights;
				}
			});
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	closeModal() {
		this.modalService.close();
	}

	cancel() {
		this.store.dispatch(new ConfirmModalActions.PutConfirm('cancel'));
		this.closeModal();
	}

	confirm() {
		this.store.dispatch(new ConfirmModalActions.PutConfirm('ok'));
		this.closeModal();
	}

	INDRA_getFeature(flight) {
		let featureSelected: any;
		for (const i in flight.ancillaries) {
			if (flight.ancillaries[i].id == this.feature) {
				featureSelected = flight.ancillaries[i];
				break;
			}
		}

		return featureSelected;
	}
}
